export enum FileTypes {
  jpeg = 'jpeg',
  jpg = 'jpg',
  png = 'png',
  bmp = 'bmp',
  gif = 'gif',
  pdf = 'pdf',
  doc = 'doc',
  xls = 'xls',
}
